import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tab from '@mui/material/Tab';

type TabPanelProps = {
    currentTab: number;
    connectedTab: number;
};

export let StyledTab = styled(Tab)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.main,
    fontSize: '14px',
    color: theme.palette.secondary.contrastText,
    '&.Mui-selected': {
        color: theme.palette.secondary.contrastText
    },
    textTransform: 'capitalize'
}));

export function a11yProps(index: number) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`
    };
}

export function TabPanel({
    currentTab,
    connectedTab,
    children
}: TabPanelProps & { children: React.ReactNode }) {
    return (
        <div
            role="tabpanel"
            hidden={currentTab !== connectedTab}
            id={`tabpanel-${connectedTab}`}
            aria-labelledby={`tab-${connectedTab}`}
        >
            {children}
        </div>
    );
}
